import {
  AccessDeniedError,
  BadRequestError,
  ConnectionError,
  HttpTypes,
  InternalServerError,
  TooManyRequestsError,
  UnexpectedError,
} from 'src/http';
import { httpResponseHandler } from 'src/http/http-response-handler';
import { endpoints } from 'src/utils/axios';
import { Either } from 'src/utils/either';

export class FaqRepository {
  constructor(private api: HttpTypes.HttpClient) {}

  async getFaqList(): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.personalization.faq.list,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getFaqDetails(
    id: string
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.personalization.faq.details,
      params: {
        faqId: id,
      },
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async createFaq(
    faq: any
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: endpoints.personalization.faq.new,
      body: faq,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async updateFaq(
    faq: any
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'put',
      url: endpoints.personalization.faq.edit,
      body: faq,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }
}
